<template>
  <HubContainer id="saleHub">

    <template v-if="atLeastCompanyAdmin">
      <HubSection icon="icon/hub/check-pos-status.svg" v-if="!moduleActivated.payAtTheTable"
                  :title="$t('sales.title')"
                  :description="$t('sales.description')"
                  :buttonAction="goToSales">
      </HubSection>

      <template v-if="moduleActivated.payAtTheTable">
        <HubSection icon="icon/hub/online-ordering.svg"
                    :title="$t('settings.online_ordering')"
                    :description="$t('sales.online_description')"
                    :buttonAction="goToSales">
        </HubSection>

        <HubSection icon="icon/hub/qr-payment.svg" v-if="this.isCompanyLevel"
                    :title="$t('services.qr_payment')"
                    :description="$t('sales.qr_pay_description')"
                    :buttonAction="goToTableSales">
        </HubSection>
      </template>

      <HubSection icon="icon/hub/sales.svg"
                  :title="$t('sale_report.title')"
                  :description="$t('sale_report.description')"
                  :buttonAction="goToSaleReport">
      </HubSection>

      <template>
        <HubSection icon="icon/hub/sales.svg" v-if="moduleActivated.POS"
                    :title="$t('pos.sales.pos_sales')"
                    :description="$t('pos.sales.pos_sales_description')"
                    :buttonAction="goToPosSales">
        </HubSection>

        <HubSection icon="icon/hub/invoices.svg" v-if="moduleActivated.POS"
                    :title="$t('pos.pos_invoices.pos_invoices')"
                    :description="$t('pos.pos_invoices.pos_invoices_description')"
                    :buttonAction="goToPosInvoices">
        </HubSection>
      </template>
    </template>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "saleHub",

    components: { HubSection, HubContainer },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "sales.title";
      this.$store.state.pageIcon = "icon/nav/taxes.svg";

      if (this.isCompanyLevel) {
        let companyModule = await this.$store.getters.getContextCompanyActivatedModule;
        Object.assign(this.moduleActivated, companyModule);
      }
    },

    data() {
      return {
        moduleActivated: {
          onlineOrdering: false,
          kiosk: false,
          mobileApp: false,
          menuBoard: false,
          loyalty: false,
          thirdPartyLoyalty: false,
          aimsVouchers: false,
          onSiteOrdering: false,
          payAtTheTable: false,
          catering: false,
          dispatch: false,
          POS: false,
        }
      }
    },

    computed: {
      atLeastBranchAdmin() {
        return this.$store.getters.loggedUserHasBranchAdmin;
      },
      atLeastCompanyAdmin() {
        return this.$store.getters.loggedUserHasCompanyAdmin;
      },
      isCompanyLevel() {
        return this.$route.query.company;
      },
    },

    methods: {
      goToSales() {
        this.$router.push(this.$router.buildContext("/sales"));
      },
      goToSaleReport() {
        this.$router.push(this.$router.buildContext("/report/sale"));
      },
      goToTableSales() {
        this.$router.push(this.$router.buildContext("/sales/table"));
      },
      goToPosSales() {
        this.$router.push(this.$router.buildContext("/pos-sales"));
      },
      goToPosInvoices() {
        this.$router.push(this.$router.buildContext("/pos-invoices"));
      },
    }
  }
</script>